export const extractKeyFromUrl = (url) => {
    const urlObj = new URL(url);
    return urlObj.pathname.slice(1); // remove the leading '/'
};
